import { IAlertDetailResponse, IAlertSearchPayload } from '~/utils/interface/alert';
import axiosClient from './axiosClient';

const alertApi = {
  postAlert(data: IAlertSearchPayload) {
    return axiosClient.post('/api/notification/find', data);
  },
  getAlertDetail(id: string): Promise<{ data: IAlertDetailResponse }> {
    return axiosClient.get(`/api/notification/detail/${id}`);
  },
  getAlertObjects(): Promise<{ data: string[] }> {
    return axiosClient.get('/api/notification/list-alert-object');
  },
};
export default alertApi;
